import { addHours, isPast, isThisWeek, setMinutes } from "date-fns";
import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store";

const selectCalendarState = (state: RootState) => state.calendar;

export const selectSelectedEventId = createSelector(
  selectCalendarState,
  calendarState => calendarState.selectedEventId,
);

export const selectCalendarView = createSelector(
  selectCalendarState,
  calendarState => calendarState.view,
);

export const selectCalendarInitialDate = createSelector(
  selectCalendarState,
  calendarState => calendarState.initialDate,
);

export const selectNewLessonDefaultDate = createSelector(
  selectCalendarState,
  calendarState => {
    if (
      isThisWeek(calendarState.initialDate || new Date()) &&
      isPast(calendarState.initialDate || new Date())
    ) {
      return addHours(setMinutes(new Date(), 0), 1);
    }

    return calendarState.initialDate;
  },
);

export const selectCalendarEventsLoading = createSelector(
  selectCalendarState,
  calendarState => calendarState.eventsLoading,
);

export const selectCalendarShowAddLessonModal = createSelector(
  selectCalendarState,
  calendarState => calendarState.showAddLessonModal,
);
